{
  "max100Characters": "กรอกได้สูงสุด 100 อักขระ",
  "noSpecialOrNumbers": "ห้ามมีอักขระพิเศษหรือตัวเลข",
  "noSpecialCharacters": "ห้ามมีอักขระพิเศษ",
  "digitsOnly": "โปรดกรอกตัวเลขเท่านั้น",
  "max30Digits": "กรอกได้สูงสุด 30 หลัก",
  "max254Characters": "กรอกได้สูงสุด 254 อักขระ",
  "max15Digits": "กรอกได้สูงสุด 15 หลัก",
  "exactly16Digits": "โปรดกรอกตัวเลข 16 หลัก",
  "fiveToTenDigits": "โปรดกรอกตัวเลข 5 ถึง 10 หลัก",
  "accountAlreadyAdded": "เพิ่ม {{method}} นี้แล้ว โปรดกรอกใหม่",
  "qrCodeNotFound": "ไม่พบคิวอาร์โค้ดรับเงิน",
  "uploadReceivingCode": "อัปโหลดคิวอาร์โค้ดรับเงิน",
  "reupload": "อัปโหลดอีกครั้ง",
  "confirm": "ยืนยัน",
  "namePlaceholder": {
    "bank": "กรอกชื่อเจ้าของบัตร",
    "alipay": "กรอกชื่อที่ยืนยันตัวตนกับ Alipay",
    "wechat": "กรอกชื่อที่ยืนยันตัวตนกับ WeChat",
    "ermb": "กรอกชื่อที่ยืนยันตัวตนสำหรับกระเป๋าเงินดิจิทัล",
    "qq": "กรอกชื่อที่ยืนยันตัวตนกับ QQ"
  },
  "accountLabel": {
    "bank": "หมายเลขบัตรธนาคาร",
    "alipay": "บัญชี Alipay",
    "wechat": "หมายเลขโทรศัพท์ WeChat",
    "ermb": "หมายเลขกระเป๋าเงิน",
    "qq": "หมายเลข QQ"
  },
  "maximumTwenty": "ตั้งค่าได้สูงสุด 20 วิธี",
  "title": "วิธีรับและชำระเงิน",
  "transactionPasswordIncorrect": "รหัสผ่านสำหรับการทำรายการไม่ถูกต้อง",
  "retryMinutes": "{{count}} นาที",
  "retryHours": "{{count}} ชั่วโมง",
  "transactionPasswordLocked": "รหัสผ่านสำหรับการทำรายการถูกล็อกชั่วคราว โปรดลองใหม่ภายหลังหรือตั้งรหัสผ่านใหม่",
  "transactionPasswordLockedUntil": "รหัสผ่านสำหรับการทำรายการถูกล็อกชั่วคราว โปรดลองอีกครั้งใน {{delay}} หรือตั้งรหัสผ่านใหม่",
  "transactionPasswordLastAttempt": "รหัสผ่านสำหรับการทำรายการไม่ถูกต้อง เหลือโอกาสอีก 1 ครั้ง; หากกรอกผิดอีกจะถูกล็อกชั่วคราว",
  "transactionPasswordAttemptsRemaining": "รหัสผ่านสำหรับการทำรายการไม่ถูกต้อง เหลือโอกาสอีก {{count}} ครั้ง",
  "refresh": "รีเฟรช",
  "selectedReceivingMethodCount": "เลือกวิธีรับเงิน {{count}} วิธี",
  "add": "เพิ่ม",
  "matchingNameHint": "จะแสดงเฉพาะวิธีชำระเงินที่ชื่อตรงกับชื่อที่ยืนยันตัวตน หากไม่พบ โปรดเพิ่มวิธีชำระเงินที่ใช้ชื่อเดียวกับการยืนยันตัวตน",
  "noPaymentMethods": "ยังไม่มีวิธีรับหรือชำระเงิน",
  "addPaymentMethod": "เพิ่มวิธีรับหรือชำระเงิน",
  "selected": "เลือกแล้ว",
  "added": "เพิ่มวิธีรับหรือชำระเงินสำเร็จ",
  "addFailed": "เพิ่มวิธีรับหรือชำระเงินไม่สำเร็จ",
  "deleted": "ลบวิธีรับหรือชำระเงินสำเร็จ",
  "deleteFailed": "ลบวิธีรับหรือชำระเงินไม่สำเร็จ",
  "updated": "แก้ไขวิธีรับหรือชำระเงินสำเร็จ",
  "updateFailed": "แก้ไขวิธีรับหรือชำระเงินไม่สำเร็จ",
  "confirmDelete": "ยืนยันการลบวิธีรับหรือชำระเงิน",
  "confirmDeleteDescription": "คุณแน่ใจว่าต้องการลบวิธีรับหรือชำระเงินนี้หรือไม่ {{lastOne}}",
  "lastPaymentMethod": "นี่คือวิธีรับหรือชำระเงินสุดท้ายของคุณ",
  "delete": "ลบ",
  "receivingCodeLabel": {
    "alipay": "คิวอาร์โค้ดรับเงิน Alipay",
    "wechat": "คิวอาร์โค้ดรับเงิน WeChat",
    "qq": "คิวอาร์โค้ดรับเงิน QQ"
  }
}
